import { render, staticRenderFns } from "./LoginToOnlineBanking.vue?vue&type=template&id=84cfa1cc&scoped=true&"
import script from "./LoginToOnlineBanking.vue?vue&type=script&lang=js&"
export * from "./LoginToOnlineBanking.vue?vue&type=script&lang=js&"
import style0 from "./LoginToOnlineBanking.vue?vue&type=style&index=0&id=84cfa1cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cfa1cc",
  null
  
)

export default component.exports